import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#F0F0F0",
  d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#0052B4",
  d: "m23.478 12 .42-1.565a12 12 0 0 0-.311-1.565h-12.63V.046a12 12 0 0 0-1.566.24l-2.087 1.28-1.043-.106q-.826.45-1.566 1.02v6.39H.413q-.207.764-.311 1.565L.522 12l-.42 1.565q.105.801.311 1.565h4.282v6.39q.741.57 1.566 1.02l1.565-.105 1.565 1.28q.766.169 1.565.24V15.13h12.63q.207-.765.312-1.566z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#D80027",
  d: "M23.898 10.435H9.391V.285C8.282.531 7.231.93 6.261 1.46v8.976H.1a12.1 12.1 0 0 0 0 3.13h6.16v8.976c.97.53 2.021.928 3.13 1.174v-10.15h14.507a12.1 12.1 0 0 0 0-3.13"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }